module.exports = __webpack_public_path__ + "img/taftaf logo - Copy.14e8f6c5.png";